import gql from "graphql-tag";

export const DELETE_BOOKED_DATE_ITEMS = gql`
  mutation deleteBookedDateItems($data: [PavingCalendarInput!]!){
    deleteBookedDateItems(data: $data)
  }
`;